import { render, staticRenderFns } from "./testimonials-section.vue?vue&type=template&id=98886cfc&scoped=true"
import script from "./testimonials-section.vue?vue&type=script&lang=ts"
export * from "./testimonials-section.vue?vue&type=script&lang=ts"
import style0 from "./testimonials-section.vue?vue&type=style&index=0&id=98886cfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98886cfc",
  null
  
)

export default component.exports